














































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations, FormModes } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component({
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isEditFormVisible',
        }),
    },
})
export default class EditProjectForm extends Mixins(InputFieldMethods) {
    @Prop() public formMode: string;

    public projectName: string = '';
    public corporationId: number = null;
    public projectDescription: string = '';
    public projectImage: any = '';

    public existingImage: any = null;
    public existingImageChanged: boolean = false;

    constructor() {
        super();
    }

    @Watch('projectImage')
    public projectImageWatcher() {
        this.removeExistingProjectImage();
    }

    get projectToEdit() {
        return this.$store.getters['Projects/getProjectToEdit'];
    }

    get isEditing() {
        return (this.formMode === FormModes.Edit);
    }

    get isCreating() {
        return (this.formMode === FormModes.Create);
    }

    get errorCollection() {
        return this.errors.any();
    }

    get getCorporationsData(): any {
        return this.$store.getters['Corporations/allCorporations'];
    }

    public addProjectImage() {
        const element = (this.$refs.projectImage as HTMLInputElement);
        return this.projectImage = (element.files.length === 0) ? '' : (element.files[0] as File);
    }

    public removeProjectImage() {
        this.projectImage = '';
        const element = (this.$refs.projectImage as HTMLInputElement);
        element.type = 'text';
        element.type = 'file';
    }

    public removeExistingProjectImage() {
        this.existingImage = null;
        this.existingImageChanged = true;
    }

    public create() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.POST_PROJECTS, {
                    name: this.projectName,
                    description: this.projectDescription,
                    image: this.projectImage,
                });

                this.cancel();
            }
        });
    }

    public edit() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.EDIT_PROJECT, {
                    id: this.projectToEdit.id,
                    name: this.projectName,
                    corporationId: this.corporationId,
                    description: this.projectDescription,
                    image: this.projectImage,
                    imageChanged: this.existingImageChanged,
                });

                this.cancel();
            }
        });
    }

    public cancel() {
        if (this.isEditing) {
            this.$store.commit(Mutations.HIDE_EDIT_PROJECT_FORM);
            this.$store.commit(Mutations.SET_PROJECT_TO_EDIT, null);
        } else {
            this.$store.dispatch(Actions.HIDE_FORM);
        }
    }

    public mounted() {
        if (this.isEditing && this.projectToEdit) {
            const project = this.projectToEdit;

            this.projectName        = project.name;
            this.corporationId      = project.corporationId;
            this.projectDescription = project.description;
            this.existingImage      = project.image;
        }
    }
}
